import * as R from 'ramda';

export const numberSuffix = R.cond([
    [R.equals(1), R.always('st')],
    [R.equals(2), R.always('nd')],
    [R.equals(3), R.always('rd')],
    [R.T, R.always('th')],
]);
